module.exports = __webpack_public_path__ + "static/membership-control-promo-df8a28dde28ee97321a3f3e0036592af.jpg";